{
  "promoter": {
    "agreement": {
      "title": "Firma tu acuerdo de promotor",
      "body": "Lee el acuerdo. Tienes que firmarlo antes de ver tu panel.",
      "program": "Programa",
      "version": "Versión",
      "fingerprint": "Huella del documento (SHA-256), calculada en este dispositivo",
      "fingerprintMismatch": "El archivo recibido no coincide con el acuerdo registrado. Recarga la página antes de firmar.",
      "pdfTitle": "Acuerdo de promotor (PDF)",
      "pdfFallback": "Tu navegador no puede mostrar el PDF aquí. Usa Abrir PDF para leerlo.",
      "consentTitle": "Consentimiento para registros y firmas electrónicos",
      "consentVersion": "Versión del texto de consentimiento {{version}}",
      "consentCheckbox": "Leí el texto de arriba y acepto usar registros y firmas electrónicos.",
      "signatureTitle": "Tu firma",
      "signatureHint": "Dibuja tu firma con el dedo, un lápiz o el ratón.",
      "signatureLabel": "Recuadro de firma",
      "clear": "Borrar",
      "sign": "Firmar el acuerdo",
      "signing": "Firmando…",
      "reload": "Recargar el acuerdo"
    }
  }
}
